import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_23c71ce2 from 'nuxt_plugin_plugin_23c71ce2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_76cfd4bf from 'nuxt_plugin_plugin_76cfd4bf' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_libplugin335a2b95_40284f1e from 'nuxt_plugin_libplugin335a2b95_40284f1e' // Source: ./lib.plugin.335a2b95.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_2fab7200 from 'nuxt_plugin_nuxtleaflet_2fab7200' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_localforage_25ee55fa from 'nuxt_plugin_localforage_25ee55fa' // Source: ./localforage.js (mode: 'client')
import nuxt_plugin_moment_23ac89da from 'nuxt_plugin_moment_23ac89da' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_54ad89b6 from 'nuxt_plugin_axios_54ad89b6' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_dbd109fe from 'nuxt_plugin_workbox_dbd109fe' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_7beb9dd8 from 'nuxt_plugin_metaplugin_7beb9dd8' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_729c52f0 from 'nuxt_plugin_iconplugin_729c52f0' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_bar_5e4624dd from 'nuxt_plugin_bar_5e4624dd' // Source: ../plugins/bar (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'client')
import nuxt_plugin_errorhandler_7194ca70 from 'nuxt_plugin_errorhandler_7194ca70' // Source: ../plugins/error-handler.js (mode: 'client')
import nuxt_plugin_notify_3d9f4950 from 'nuxt_plugin_notify_3d9f4950' // Source: ../plugins/notify.js (mode: 'client')
import nuxt_plugin_global_f21f4e84 from 'nuxt_plugin_global_f21f4e84' // Source: ../plugins/global.js (mode: 'client')
import nuxt_plugin_repository_02bac980 from 'nuxt_plugin_repository_02bac980' // Source: ../plugins/repository (mode: 'client')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'client')
import nuxt_plugin_schema_66b1fe00 from 'nuxt_plugin_schema_66b1fe00' // Source: ../plugins/schema.js (mode: 'client')
import nuxt_plugin_pwaupdate_81602bf6 from 'nuxt_plugin_pwaupdate_81602bf6' // Source: ../plugins/pwa-update.js (mode: 'client')
import nuxt_plugin_plugin_b7c2cebe from 'nuxt_plugin_plugin_b7c2cebe' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - Water Management Software","title":"Edge Marketing + Design","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_23c71ce2 === 'function') {
    await nuxt_plugin_plugin_23c71ce2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_76cfd4bf === 'function') {
    await nuxt_plugin_plugin_76cfd4bf(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin335a2b95_40284f1e === 'function') {
    await nuxt_plugin_libplugin335a2b95_40284f1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_2fab7200 === 'function') {
    await nuxt_plugin_nuxtleaflet_2fab7200(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localforage_25ee55fa === 'function') {
    await nuxt_plugin_localforage_25ee55fa(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_23ac89da === 'function') {
    await nuxt_plugin_moment_23ac89da(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_54ad89b6 === 'function') {
    await nuxt_plugin_axios_54ad89b6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_dbd109fe === 'function') {
    await nuxt_plugin_workbox_dbd109fe(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_7beb9dd8 === 'function') {
    await nuxt_plugin_metaplugin_7beb9dd8(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_729c52f0 === 'function') {
    await nuxt_plugin_iconplugin_729c52f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bar_5e4624dd === 'function') {
    await nuxt_plugin_bar_5e4624dd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_errorhandler_7194ca70 === 'function') {
    await nuxt_plugin_errorhandler_7194ca70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notify_3d9f4950 === 'function') {
    await nuxt_plugin_notify_3d9f4950(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_global_f21f4e84 === 'function') {
    await nuxt_plugin_global_f21f4e84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_repository_02bac980 === 'function') {
    await nuxt_plugin_repository_02bac980(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_schema_66b1fe00 === 'function') {
    await nuxt_plugin_schema_66b1fe00(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwaupdate_81602bf6 === 'function') {
    await nuxt_plugin_pwaupdate_81602bf6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_b7c2cebe === 'function') {
    await nuxt_plugin_plugin_b7c2cebe(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
